import { EventsChartComponent } from './eventschart/eventschart.component';
import { AngularGaugeComponent } from './angulargauge/angulargauge.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgGridModule } from 'ag-grid-angular/main';
import { ModalModule } from 'ng2-bootstrap';
import { GridListWidgetComponent } from './grid-list/grid-list.component';
import { UserListComponent } from './user-list/user-list.component';
import { TabsModule } from 'ng2-bootstrap';
import { BarchartWidgetComponent } from './barchart/barchart.component';
import { EntityDisplayWidgetComponent } from './entity-display/entity-display.component';
import { EntityRecordEditButtonComponent } from './entity-edit-button/entityrecord-edit-button.component';
import { EntityAddButtonComponent } from './entity-add-button/entity-add-button.component';
import { FilterButtonComponent } from './filter-button/filter-button.component';
import { FilterDisplayComponent } from './filter-display/filter-display.component';
import { LineChartComponent } from './linechart/linechart.component';
import { MetricWidgetComponent } from './metric/metric.component';
import { MetricTargetWidgetComponent } from './metric-target/metric-target.component';
import { PreviousActivitiesWidgetComponent } from './previousactivities/previousactivities.component';
import { NextStepsWidgetComponent } from './nextsteps/nextsteps.component';
import { PieChartComponent } from './piechart/piechart.component';
import { TableWidgetComponent } from './table/table.component';
import { TableDisplayComponent } from './table-display/table-display.component';
import { ActivityWidgetComponent } from './activity/activity.component';
import { ActivityScrollComponent } from './activity-scroll/activity-scroll.component';
import { EmailButtonComponent } from './email-button/email-button.component';
import { ProfilePhotoComponent } from './profile-photo/profile-photo.component';
import { CustomFieldsModule } from '../fields/fields.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from 'ng-formly';
import { AmChartsModule } from '@amcharts/amcharts3-angular';
import { NgPipesModule } from 'ngx-pipes';
import { MomentModule } from 'angular2-moment';
import { NotesDisplayComponent } from './notes-display/notes-display.component';
import { NotesTextBoxComponent } from './notes-textbox/notes-textbox.component';
import { ChartComponent } from './chart/chart.component';
import { GridButtonsComponent } from './grid-list/grid-buttons.component';
import { SimpleNotificationsModule, PushNotificationsModule } from 'angular2-notifications';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

//Formly Fields
import {
    DataElementSelect,
    DatePicker,
    DateRangePicker,
    EntityfieldMultipleSelect,
    EntityfieldSelect,
    CascadedLookup,
    EntityRecordSelectMultiple,
    EntitySelect,
    EntitySelectMultiple,
    InputField,
    PagelayoutSelect,
    PicklistLookup,
    PicklistRadio,
    PicklistSelect,
    ReadonlyField,
    RepeatComponent,
    OptionSelect,
    OptionSelectMultiple,
    ComponentSelect,
    ComponentSelectMultiple,
    SearchlayoutSelect,
    SubEntity,
    TextAreaField,
    TimePicker,
    ToggleCheckbox,
    UserSelect
} from '../../components/fields';
import { EntityFieldEditableComponent } from "./entityfield-editable/entityfield-editable.component";
// File upload module
import { FileUploadModule } from 'ng2-file-upload';
// Cloudinary module
import { CloudinaryModule, CloudinaryConfiguration, provideCloudinary } from '@cloudinary/angular-4.x';
import cloudinaryConfiguration from '../../config/cloudinary.config';
import * as cloudinary from 'cloudinary-core';
import { DisplayListComponent } from './display-list/display-list.component';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        MomentModule,
        NgPipesModule,
        TabsModule.forRoot(),
        AmChartsModule,
        CommonModule,
        FormsModule,
        ModalModule.forRoot(),
        CustomFieldsModule,
        ReactiveFormsModule,
        Ng2TableModule,
        InfiniteScrollModule,
        FormlyModule,
        SimpleNotificationsModule.forRoot(),
        PushNotificationsModule,
        AgGridModule.withComponents([
            GridButtonsComponent
        ]),
        CloudinaryModule.forRoot(cloudinary, cloudinaryConfiguration),
        FileUploadModule,
        RouterModule
    ],
    declarations: [
        PreviousActivitiesWidgetComponent,
        NextStepsWidgetComponent,
        ActivityWidgetComponent,
        ActivityScrollComponent,
        GridListWidgetComponent,
        GridButtonsComponent,
        MetricTargetWidgetComponent,
        BarchartWidgetComponent,
        EntityDisplayWidgetComponent,
        EntityRecordEditButtonComponent,
        EntityAddButtonComponent,
        EntityFieldEditableComponent,
        FilterDisplayComponent,
        FilterButtonComponent,
        LineChartComponent,
        MetricWidgetComponent,
        PieChartComponent,
        TableWidgetComponent,
        TableDisplayComponent,
        AngularGaugeComponent,
        EventsChartComponent,
        EmailButtonComponent,
        NotesDisplayComponent,
        NotesTextBoxComponent,
        UserListComponent,
        ChartComponent,
        ProfilePhotoComponent,
        DisplayListComponent
    ],
    exports: [
        PreviousActivitiesWidgetComponent,
        NextStepsWidgetComponent,
        ActivityWidgetComponent,
        ActivityScrollComponent,
        GridListWidgetComponent,
        MetricTargetWidgetComponent,
        BarchartWidgetComponent,
        EntityDisplayWidgetComponent,
        EntityRecordEditButtonComponent,
        EntityAddButtonComponent,
        EntityFieldEditableComponent,
        FilterDisplayComponent,
        FilterButtonComponent,
        LineChartComponent,
        MetricWidgetComponent,
        PieChartComponent,
        TableWidgetComponent,
        TableDisplayComponent,
        AngularGaugeComponent,
        EventsChartComponent,
        EmailButtonComponent,
        NotesDisplayComponent,
        NotesTextBoxComponent,
        UserListComponent,
        ChartComponent,
        ProfilePhotoComponent
    ]
})
export class WidgetsModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/widgets.module.ts